const DefaultData = {
  APISERVERURL: 'https://zotraiapi.azurewebsites.net/api/',
  APILOCALURL: 'http://localhost:5126/api/',
  APIACTIVEURL: 'https://zotraiapi.azurewebsites.net/api/',
  DEFAULTPAYMENTGATEWAYFEE: 2.5,
  DEFAULTCURRENCY: 'INR',
  DEFAULTCOMPANYNAME: 'SAAR DEVELOPERS CODE PRIVATE LIMITED',
  DEFAULTBRANDNAME: 'ZOTRAI',
  USERTYPE: "CUSTOMER",
  DOMESTICFLIGHTFEE: "0",
  INTERNATIONALFLIGHTFEE: "0",
  DOMESTICHOTELBOOKINGFEE: "0",
  INTERNATIONALHOTELBOOKINGFEE: "0",
  BUSBOOKINGFEE: "0",
  PaymentGatewayFee: "2",
  DEFAULTCOMPANYID: "d19eb72e-9995-4380-8e23-6a6e5316e035",
  // TESTING ONLY — when true, HotelReview skips the Razorpay checkout and
  // books directly with a dummy payment reference. Must be false in production.
  BYPASSHOTELPAYMENT: false,
  // TESTING ONLY — when true, BusPayment skips the Razorpay checkout and
  // books directly with a dummy payment reference. Must be false in production.
  BYPASSBUSPAYMENT: false,
  // TESTING ONLY — when true, flight review/checkout skips the Razorpay checkout
  // and books directly with a dummy payment reference. Must be false in production.
  BYPASSFLIGHTPAYMENT: false,
};
export const S3_BASE_URL = 'https://trawtelcdn.s3.eu-north-1.amazonaws.com/';
export default DefaultData;